"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@emotion/react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Icon = _interopRequireDefault(require("../atoms/Icon"));
var _Column = _interopRequireDefault(require("../layout/Column"));
var _Row = _interopRequireDefault(require("../layout/Row"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  value: false,
  className: '',
  wrapperTag: 'section'
};
function Collapsable(props) {
  const {
    value,
    header,
    children,
    containerStyles,
    className,
    wrapperTag
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const [isItCollapsed, setIsItCollapsed] = (0, _react.useState)(value);
  const {
    colors
  } = (0, _react2.useTheme)();
  const toggleIsItCollapsed = () => setIsItCollapsed(!isItCollapsed);
  (0, _react.useEffect)(() => {
    if (value) setIsItCollapsed(value);
  }, [value]);
  return /*#__PURE__*/_react.default.createElement(StyledWrapper, {
    align: "center",
    gap: 10,
    styles: containerStyles,
    className: className,
    as: wrapperTag
  }, /*#__PURE__*/_react.default.createElement(_Row.default, {
    onClick: toggleIsItCollapsed,
    gap: 0,
    styles: cssHeaderContainerStyles,
    as: "header"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: isItCollapsed ? 'arrow_drop_down' : 'arrow_right',
    size: 25,
    color: colors.FONT.TITLE
  }), header), isItCollapsed ? /*#__PURE__*/_react.default.createElement(_Column.default, {
    gap: 0
  }, children) : null);
}
const StyledWrapper = (0, _styled.default)(_Column.default)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
const cssHeaderContainerStyles = (0, _react2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));
var _default = exports.default = Collapsable;